.viewer {
  display: flex;
  flex-direction: column;
  height: 82vh;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ib-line);
  background: var(--ib-panel);
}

.title {
  font-family: var(--font-serif);
  font-weight: 700;
  font-size: 15px;
  color: var(--ib-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  gap: 8px;
  flex: none;
}

.action,
.close {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--ib-line);
  background: var(--ib-panel);
  color: var(--ib-ink);
  font-weight: 600;
  font-size: 13px;
  padding: 7px 13px;
  border-radius: 8px;
  cursor: pointer;
}

.action:hover {
  border-color: var(--ib-red);
  color: var(--ib-red);
}

.close {
  background: var(--ib-red);
  color: #ffffff;
  border-color: var(--ib-red);
}

.close:hover {
  background: var(--ib-red-d);
}

.frame {
  flex: 1;
  width: 100%;
  border: 0;
  background: #f3f3f3;
}

.fallback {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: #f3f3f3;
}

.fallbackText {
  margin: 0;
  color: var(--ib-muted);
  font-size: 14px;
}
